import React, { useEffect, useRef } from 'react';

// React wrapper for the global ApexCharts loaded via CDN.
// Destroys and re-creates the chart whenever options/series change.
const Chart = ({ options, series, type, height, width }) => {
  const containerRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current || !window.ApexCharts) return undefined;

    if (instanceRef.current) {
      instanceRef.current.destroy();
      instanceRef.current = null;
    }

    const opt = {
      ...options,
      series,
      chart: {
        ...(options?.chart || {}),
        type,
        height,
        width: width || '100%',
      },
    };

    instanceRef.current = new window.ApexCharts(containerRef.current, opt);
    instanceRef.current.render();

    return () => {
      if (instanceRef.current) {
        instanceRef.current.destroy();
        instanceRef.current = null;
      }
    };
  }, [options, series, type, height, width]);

  return <div ref={containerRef} />;
};

export default Chart;
